import { Outlet } from 'react-router-dom';

const GuardedRoute = () => {
  return <Outlet />;
};

export default GuardedRoute;
